package gr.tech.meetinggenie.models.meeting

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class DealStatus {
    @SerialName("lost")         LOST,
    @SerialName("old_inactive") OLD_INACTIVE,
    @SerialName("delayed")      DELAYED;

    val label get() = when (this) {
        LOST         -> "Lost"
        OLD_INACTIVE -> "Old/Inactive"
        DELAYED      -> "Delayed"
    }
}

@Serializable
enum class LossReason {
    @SerialName("budget")           BUDGET,
    @SerialName("timing")           TIMING,
    @SerialName("competition")      COMPETITION,
    @SerialName("no_decision")      NO_DECISION,
    @SerialName("internal_blocker") INTERNAL_BLOCKER,
    @SerialName("other")            OTHER;

    val label get() = when (this) {
        BUDGET           -> "Budget"
        TIMING           -> "Timing"
        COMPETITION      -> "Competition"
        NO_DECISION      -> "No decision"
        INTERNAL_BLOCKER -> "Internal blocker"
        OTHER            -> "Other"
    }
}

@Serializable
data class LossDTO(
    var accountName: String = "",
    var dealStatus: DealStatus? = null,
    var primaryReason: LossReason? = null,
    var lessonOrSignal: String = ""
)
